import { LoadingBadge } from './loadingBadge';

export const LoadingTripBoxes = () => {
  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
      {[{}, {}, {}].map((_, index) => (
        <div
          key={index}
          className="flex flex-col group relative bg-surface rounded-3xl p-3 shadow-sm ring-1 ring-gray-900/5"
        >
          <div className="relative w-full">
            <div className="aspect-[3/2] w-full rounded-2xl animate-pulse bg-muted object-cover" />
          </div>
          <div className="mt-4 px-2 pb-2">
            <div className="flex items-center gap-x-4">
              <div className="h-10 w-10 rounded-full bg-muted animate-pulse" />
              <div className="flex flex-col gap-1">
                <LoadingBadge
                  expectedChars={12}
                  className="h-5 w-32 bg-muted animate-pulse rounded"
                />
                <div className="flex items-center gap-x-1 text-xs">
                  <LoadingBadge
                    expectedChars={7}
                    className="h-3 w-20 bg-muted animate-pulse rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
